/* EB 26 Sep 2026 (Claude): delivery-date fallback.
   The 'Get it between' Custom Liquid block fills #fromDate/#toDate with datejs 1.0
   from cdnjs. When that library fails or loads late, Date.today() throws and the
   line shows blank dates. This fills them in plain JS with the same rule
   (+2 and +7 days, Saturday/Sunday pushed to Monday) only if they are still empty,
   and hides the line if dates still cannot be shown. No other behaviour changed.
   ROLLBACK: delete this first IIFE. */
(function () {
  'use strict';
  var D = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var M = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function add(n) {
    var d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + n);
    var w = d.getDay(); if (w === 6) d.setDate(d.getDate() + 2); else if (w === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function sfx(n) { if (n > 3 && n < 21) return 'th'; return ['th','st','nd','rd'][n % 10] || 'th'; }
  function fmt(d) { return D[d.getDay()] + ' ' + M[d.getMonth()] + ' ' + d.getDate() + sfx(d.getDate()); }
  function fill() {
    try {
      var f = document.getElementById('fromDate'), t = document.getElementById('toDate');
      if (!f || !t) return;
      if (!(f.textContent || '').trim()) f.textContent = fmt(add(2));
      if (!(t.textContent || '').trim()) t.textContent = fmt(add(7));
      if (!(f.textContent || '').trim() || !(t.textContent || '').trim()) {
        var p = f.closest ? f.closest('p') : null; if (p) p.style.display = 'none';
      }
    } catch (e) { /* never block the page */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  window.addEventListener('load', fill);
})();

/* EarthBased - move the delivery estimate above the countdown, 21 Aug 2026

   WANTED ORDER inside the buy box:
     quantity + Add To Cart -> BUY NOW -> 'Get it between ...' -> countdown

   WHY JS AND NOT CSS
   The countdown (.eb-countdown-product, injected at runtime by eb-countdown.js)
   sits INSIDE form.product-buy, while the delivery estimate is a Custom Liquid
   block that is a SIBLING of the whole add-to-cart summary item. CSS order only
   reorders children of one flex container, so it cannot interleave across two
   different parents. Hence a DOM move.

   The delivery block is matched by its text, not by class: .summary-item
   .custom-liquid is a generic container and the theme may hold more than one.

   The countdown is injected asynchronously, so this retries briefly rather than
   assuming it exists at parse time. The interval self-cancels on success or
   after ~6s; the moved flag makes the move idempotent. If a product has no
   countdown, the delivery block is simply left where the theme put it. */
(function () {
  'use strict';

  function findDelivery() {
    var items = document.querySelectorAll('.product-summary-inner > .summary-item');
    for (var i = 0; i < items.length; i++) {
      if ((items[i].textContent || '').indexOf('Get it between') > -1) return items[i];
    }
    return null;
  }

  function move() {
    var timer = document.querySelector('.eb-countdown-product');
    if (!timer) return false;
    var delivery = findDelivery();
    if (!delivery) return true; /* nothing to move here - stop retrying */
    if (delivery.getAttribute('data-eb-moved') === '1') return true;
    try {
      timer.parentNode.insertBefore(delivery, timer);
      delivery.setAttribute('data-eb-moved', '1');
    } catch (e) { /* leave the original order if the move fails */ }
    return true;
  }

  if (move()) return;
  var tries = 0;
  var iv = setInterval(function () {
    if (move() || ++tries > 40) clearInterval(iv);
  }, 150);
})();
